import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { BIReport } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditBIReport from './EditBIReport.vue';

    interface Props {
        biReport: BIReport;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BIReportTableActions',
  props: {
    biReport: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.biReport }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).POWERBI_SETUP_UPDATE))
        ? (_openBlock(), _createBlock(EditBIReport, {
            key: 0,
            "bi-report": _ctx.biReport
          }, null, 8, ["bi-report"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).POWERBI_SETUP_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.powerbi.setup.destroy', _ctx.biReport.id),
            "query-key": [_unref(QueryKey).POWER_BI, selectedCompanyId.value],
            header: "bi_and_companies.delete_bi_row",
            description: "bi_and_companies.delete_bi_row_content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})